import Smartphones from 'Counterparties/Suppliers/views/SuppliersView/containers/Smartphones'
import Tablets from 'Counterparties/Suppliers/views/SuppliersView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SuppliersView = getCurrentDeviceView(Smartphones, Tablets)

export default SuppliersView
